@use 'styles/variables';
@use 'styles/mixins';

@mixin PrimaryBase {
  border: 1px solid variables.$blue-primary;

  background-color: variables.$blue-primary;

  @include mixins.FocusAndActiveBackground(variables.$blue-primary-3);
}

@mixin DisableMouse {
  cursor: not-allowed;
}

.Default {
  @include PrimaryBase;
  @include mixins.FocusShadow;
  height: 4rem;
  padding: 0 2rem;

  border-radius: 5px;

  &_Disabled {
    @include mixins.FocusAndActiveBackground(variables.$grey7);
    @include DisableMouse;
    border-color: variables.$grey7;

    background-color: variables.$grey7;
  }

  &_isBig {
    min-height: 5.6rem;
    padding: 1.8rem 3.2rem;
  }
}

.Add_More {
  height: 2.8rem;
  padding-right: 1.4rem;
  border-radius: 5px;

  background-color: variables.$grey13;

  &_Disabled {
    @include DisableMouse;
    background-color: variables.$grey6;
    filter: grayscale(1);
  }

  &_isBig {
    height: 4.4rem;
    padding-left: 0.9rem;
  }

  &_WithSamePadding {
    padding-left: 1.4rem;
  }

  &:hover {
    background-color: variables.$grey11;
  }

  &:active {
    background-color: variables.$blue-secondary-6;
  }

  &:focus {
    background-color: variables.$grey13;
    box-shadow: 0 0 6px 0 variables.$blue-secondary-5;
  }
}

.Only_Icon {
  @include PrimaryBase;
  @include mixins.FocusShadow;
  display: flex;
  height: 4rem;
  padding: 0.8rem 1.25rem;

  border-radius: 5px;
}

.WithPrimaryHover {
  &:hover {
    @include PrimaryBase;

    > * {
      filter: invert(95%) sepia(5%) saturate(0%) hue-rotate(33deg)
        brightness(105%) contrast(106%);
    }

    > span {
      color: variables.$white;

      filter: unset;
    }
  }
}

.IsSmall {
  height: auto;
  min-height: 2.8rem;
  padding: 0.2rem 0.8rem;
}

.IsWide {
  min-width: 12rem;
}

.IsWider {
  min-width: 20rem;
}

.isHeightOfFormInput {
  height: 32px;
  position: relative;
  top: 20px;
}

.PrimaryPressed {
  background-color: variables.$blue-primary-2;
}

.Outlined {
  background-color: variables.$white;

  @include mixins.FocusAndActiveBackground(variables.$grey13);
}

.OutlinedDisabled {
  @include DisableMouse;
  @include mixins.FocusAndActiveBackground(variables.$grey12);

  border-color: variables.$grey8;
}

.WithGreyBorder {
  border: 1px solid variables.$grey8;
}

.Danger {
  border-color: variables.$red4;

  background-color: variables.$red4;

  @include mixins.FocusAndActiveBackground(variables.$red4);
}

.FullWidth {
  width: 100%;
}

.Icon {
  @include mixins.flex-centered;
}

.IconLeft {
  padding-right: 1em;
}

.IconLeft_WithoutPadding {
  padding-right: 0;
}

.IconRight {
  padding-left: 1em;
}

.IconRight_WithoutPadding {
  padding-left: 0;
}

.Icon_Wrapper {
  @include mixins.flex-wrap;
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$desktop-width
) {
  .Default_isBig {
    padding: 0 2rem;
  }
}
